import React,{useEffect, useState} from 'react'
//import { useDispatch } from 'react-redux'; //remove
//import {updateDataItem} from '../../../../../../features/survey';
import MyAccordion from './MyAccordion'

import { useEyeconxStore } from '../../../../../store/eyeconxStore';
const ElementItem = (props) => {
        const {updateDataItem} = useEyeconxStore()
    const [element,setElement] = useState(props.element)
   //const dispatch = useDispatch()

   
    const handleNameChange = (e) => setElement({...element,name:e.target.value})
    const handleTitleChange = (e) => setElement({...element,title:e.target.value})
    const handleDescriptionChange = (e) => setElement({...element,description:e.target.value})
    const handleIsRequiredChange = (e) => setElement({...element,isrequired:e.target.value})
    const handleRequiredMessageChange = (e) => setElement({...element,requiredMessage:e.target.value})
    const handleMaximumLengthChange = (e) => setElement({...element,maximumLength:e.target.value})
    const handlePlaceholderChange = (e) => setElement({...element,placeholder:e.target.value})
    const handleRowsChange = (e) => setElement({...element,rows:e.target.value})

    useEffect(()=>{
        const retVal ={
            id:props.index,
            vals:element
        }
        updateDataItem(retVal)
    },[element])
    return ( 
        <>
                <MyAccordion.Item title={props.index+1+" "+element.title}>
                  <form>
                                <div className="form-group">
                                        <label htmlFor="txtName">Name:</label>
                                        <input type="text" id="name" onChange={(e)=>handleNameChange(e)} value={element.name} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group mt-2">
                                        <label htmlFor="txtName">Title:</label>
                                        <input type="text" id="title" onChange={(e)=>handleTitleChange(e)} value={element.title} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group mt-2">
                                        <label htmlFor="txtName">Description:</label>
                                        <input type="text" id="description" onChange={(e)=>handleDescriptionChange(e)} value={element.description} className="form-control form-control-sm" />
                                </div>
                              
                                <div className="form-group mt-2">
                                        <input type="checkbox" id="isrequired" onChange={(e)=>handleIsRequiredChange(e)}  className="form-check-input me-2" />
                                        <label htmlFor="chkReq"> Is Required?</label>
                                </div>
                                <div className="form-group mt-2">
                                        <label htmlFor="txtName">Is Required Message:</label>
                                        <input type="text" id="requiredmessage" onChange={(e)=>handleRequiredMessageChange(e)} value={element.requiredMessage} className="form-control form-control-sm" />
                                </div>
                                {element.type === "text" || element.type ==="comment"?<div>
                                        <div className="form-group mt-2">
                                                <label htmlFor="txtName">Placeholder Text:</label>
                                                <input type="text" id="placeholder"  onChange={(e)=>handlePlaceholderChange(e)} value={element.placeholder}  className="form-control form-control-sm" />
                                        </div>
                                        <div className="form-group mt-2">
                                                <label htmlFor="txtName">Maximum Length:</label>
                                                <input type="text" id="maximumLength" onChange={(e)=>handleMaximumLengthChange(e)} value={element.maximumLength} className="form-control form-control-sm" />
                                        </div>
                                </div>:""}
                               {element.type ==="comment" ?
                                <div className="form-group mt-2">
                                        <label htmlFor="txtName">Number of Rows:</label>
                                        <input type="text" id="rows" onChange={(e)=>handleRowsChange(e)} value={element.rows} className="form-control form-control-sm" />
                                </div>:""}
                        </form>
                </MyAccordion.Item>

           
        </>
     );
}
 
export default ElementItem;